import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faFileCheck } from '@fortawesome/pro-light-svg-icons'

import { Box, Button } from '@domain-group/suit-theme'

import useBrand from '@hooks/useBrand'
import type { UseCampaignPayload } from '@hooks/useCampaign'
import useCurrentUser from '@hooks/useCurrentUser'

import AuthenticatedDownload from '@components/AuthenticatedDownload'

import useMediaReviewer from '../../../hooks/useMediaReviewer'

interface MediaReviewerActionsProps {
  brandId: number,
  callbacks: {
    downloadMedia: UseCampaignPayload['callbacks']['downloadMedia'],
  },
  campaignId: number,
  imageIds: number[],
}

const MediaReviewerActions = (props: MediaReviewerActionsProps) => {
  const {
    brandId, callbacks: { downloadMedia }, campaignId, imageIds,
  } = props

  const { currentUser } = useCurrentUser()

  const mediaReviewerPayload = useMediaReviewer({ campaignId, selectedImageIds: imageIds })
  const { callbacks: { buildProofSheetLink } } = mediaReviewerPayload

  const brandPayload = useBrand({ id: brandId })
  const { publicLinkFontColor, publicLinkTextAccentColour } = brandPayload

  return (
    <Box
      alignItems="center"
      flexDirection={['column', 'row']}
      justifyContent="center"
      marginBottom="xlarge"
      marginTop="large"
      paddingX="large"
    >
      <Button
        buttonStyle="primaryEdit"
        icon={<FontAwesomeIcon icon={faDownload} />}
        //@ts-expect-error
        maxWidth={['auto', '30%']}
        onClick={() => downloadMedia(imageIds)}
        size="medium"
        style={{
          backgroundColor: publicLinkTextAccentColour,
          borderColor: publicLinkTextAccentColour,
          color: publicLinkFontColor,
        }}
      >
        Download All Images
      </Button>

      {currentUser.id && (
        <AuthenticatedDownload>
          <Button
            buttonStyle="secondaryUtility"
            // @ts-expect-error TS2322
            href={buildProofSheetLink()}
            icon={<FontAwesomeIcon icon={faFileCheck} />}
            marginLeft={['none', '8px']}
            marginTop={['8px', '0']}
            maxWidth={['auto', '30%']}
            size="medium"
          >
            Generate a Proofsheet
          </Button>
        </AuthenticatedDownload>
      )}
    </Box>
  )
}

export default MediaReviewerActions
